import {
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherResource,
  DispatcherEndpoint,
  AdapterSource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { DFDHeaders } from 'serverTypes/authentication';

export const GET_BCSTOKEN = 'KYRUUS.GET_BCSTOKEN';
export const GET_BCSTOKEN_SUCCESS = 'KYRUUS.GET_BCSTOKEN_SUCCESS';
export const GET_BCSTOKEN_FAIL = 'KYRUUS.GET_BCSTOKEN_FAIL';

export const getBcsToken = (issuer: string, audience: string) => {
  return {
    type: GET_BCSTOKEN,
    payload: {
      client: 'dispatcher',
      request: {
        method: 'get',
        url: getDispatcherUrl(
          DispatcherCategoryService.GET_CARE,
          DispatcherAuthPrefix.AUTHENTICATED,
          DispatcherResource.KYRUUS,
          DispatcherEndpoint.TOKEN
        ),
        headers: {
          [DFDHeaders.mhpAdapter]: AdapterSource.MHP,
          [DFDHeaders.tokenIssuer]: issuer,
          audience
        }
      }
    }
  };
};
